import Config from '../config/environment'

const { REST_API_URL } = Config

export type InvoiceMeta = {
  bankPayer: string
  bankCommissionPercentage: number
  bankCommissionAmount: number
  invoiceNumber?: string
  estimatedPaymentDate?: string
  invoiceDate?: string
  paymentDate?: string
  markAsPaidDate?: string
}

export type InvoicePayload = {
  credit: string
  status: string
  total: number
  meta?: InvoiceMeta
}

export type InvoicePopulatedCredit = {
  _id: string
  bank: { name: string }
  client: { name: string }
}

export type InvoiceResponse = {
  _id: string
  credit: InvoicePopulatedCredit
  status: string
  total: number
  meta?: InvoiceMeta
}

export const getInvoices = async function (filter?: {
  status?: string
  from?: string
  to?: string
}) {
  const params = {
    ...(filter?.status ? { status: filter.status } : {}),
  }

  const queryParams = new URLSearchParams(params).toString()
  const response = await fetch(`${REST_API_URL}/invoices/?${queryParams}`, {
    method: 'GET',
    credentials: 'include',
  })
  const data = await response.json()
  if ('error' in data) {
    throw new Error(data.error.message)
  }
  return data
}

export const updateInvoice = async function (
  id: string,
  payload: {
    status: string
    invoiceDate: Date
    paymentDate: Date
    markAsPaidDate: Date
    estimatedPaymentDate: Date
  }
) {
  const response = await fetch(`${REST_API_URL}/invoices/${id}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (response.status !== 204) {
    const data = await response.json()
    if ('error' in data) {
      throw new Error(data.error.message)
    }
  }
  return {
    invoiceUpdated: true,
  }
}

